import { PopoverService } from '../../tn.popover/service.tn.popover';
import downloadFontPopoverTemplate from './download-font-popover.html';

function tnDownloadFontButtonController() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const popover = this;
    popover.type = 'desktop';

    //TODO: Update with correct file link
    popover.url = '/api/1/at-font-face/' + popover.style.family + '.css';

    //TODO: Update with correct css link
    popover.css =
        '<link rel="stylesheet" href="/api/1/at-font-face/' +
        popover.style.family +
        '.css">';
    
    popover.selectCss = function () {
        popover.cssFieldElement.select();
    };
}

tnDownloadFontButton.$inject = ['$tnPopover'];
export default function tnDownloadFontButton($tnPopover: PopoverService) {
    return {
        controller: tnDownloadFontButtonController,
        controllerAs: 'popover',
        bindToController: true,
        template: downloadFontPopoverTemplate,
        link: function (scope, element) {
            scope.downloadPopover = $tnPopover.popoverXS(
                element.find('div.popover__download_font')
            );

            scope.popover.cssFieldElement = element.find(
                '.download_font_css_field'
            );

            // Parent is relative.  To get absolute position to work we detach it from the DOM
            element.find('div.popover__download_font').detach();
        },
    };
}
